module.exports = __webpack_public_path__ + "img/planet-green.8b9f604f.svg";